/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    RESET_title: "New password",
    RESET_greeting: "Hello {0},",
    RESET_intro: "Choose a new password for your account.",
    RESET_password: "New password",
    RESET_passwordPlaceholder: "Your new password",
    RESET_confirmPassword: "Confirm password",
    RESET_confirmPasswordPlaceholder: "Confirm your password",
    RESET_submit: "Reset my password",
    RESET_loading: "Loading…",
    RESET_mismatch: "The passwords do not match.",
    RESET_invalid: "This reset link is invalid or has expired.",
    RESET_requestNew: "Request a new link",
    RESET_success: "Password reset",
    RESET_successMessage: "Your password has been reset. You can now sign in.",
    RESET_goToSignIn: "Sign in"
};
